import type { ReactNode } from "react";
import { UserOutlined } from "@ant-design/icons";
import { Avatar, Divider, Flex, Popover } from "antd";
import classNames from "classnames";
import { NavLink } from "../../../../router/LocaleLink";
import { useTranslation } from "react-i18next";

import { useAuth } from "../../../../api/auth/useAuth";
import { LogoutIcon } from "../../../../assets/icons";
import { MenuItems } from "./links";
import { Link } from "../../../../router/LocaleLink";
import { Button } from "../../../components/CustomAntdComponents/Button";
import { Paths } from "../../../../router/paths";
import { useAuthEntryPath } from "../../../../router/useAuthEntryPath";
import { useLocalizedPath } from "../../../../i18n/useAppLocale";
import styles from "./ProfileMenu.module.css";

type MenuItem = {
  icon: ReactNode;
  labelKey: string;
  path: string;
};

const ProgileMenuContent = () => {
  const { t } = useTranslation();
  const { logout, user } = useAuth();
  const loginPath = useAuthEntryPath(Paths.LOGIN);
  const signUpPath = useAuthEntryPath(Paths.SIGN_UP);
  const localize = useLocalizedPath();

  const roleKey = (user?.role?.name as keyof typeof MenuItems) || "user";
  const menuGroup = MenuItems[roleKey] || MenuItems.user;
  const links = Object.values(menuGroup) as MenuItem[];

  return (
    <div>
      {user && (
        <>
          {links.slice(0, 4).map((link) => {
            return (
              <NavLink
                key={link.path}
                to={localize(link.path)}
                className={({ isActive }) =>
                  classNames(styles["menuItem"], {
                    [styles.activeMenuItem]: isActive,
                  })
                }
              >
                <Flex align="center" gap={8}>
                  {link.icon}
                  <div className={styles.label}>{t(link.labelKey)}</div>
                </Flex>
              </NavLink>
            );
          })}
          <Divider className={styles.divider} />
          {links.slice(4).map((link) => {
            return (
              <NavLink
                key={link.path}
                to={localize(link.path)}
                className={({ isActive }) =>
                  classNames(styles["menuItem"], {
                    [styles.activeMenuItem]: isActive,
                  })
                }
              >
                <Flex align="center" gap={8}>
                  {link.icon}
                  <div className={styles.label}>{t(link.labelKey)}</div>
                </Flex>
              </NavLink>
            );
          })}
        </>
      )}
      {user ? (
        <a className={styles.menuItem} onClick={logout}>
          <Flex align="center" gap={8}>
            <LogoutIcon />
            <div className={styles.label}>{t("layout.profileMenu.signOut")}</div>
          </Flex>
        </a>
      ) : (
        <Flex gap={"8px"}>
          <Link to={loginPath}>
            <Button style={{ width: "100%" }} type="default">
              {t("layout.login")}
            </Button>
          </Link>
          <Link to={signUpPath}>
            <Button type="primary">{t("layout.signUp")}</Button>
          </Link>
        </Flex>
      )}
    </div>
  );
};

export const ProfileMenu = () => {
  const { user } = useAuth();

  return (
    <Popover
      className={styles.myPopover}
      content={ProgileMenuContent}
      trigger="click"
      placement="bottomLeft"
    >
      {user?.user?.image ? (
        <Avatar src={user?.user?.image} className={styles.avatar} />
      ) : (
        <Avatar icon={<UserOutlined />} className={styles.avatar} />
      )}
    </Popover>
  );
};
